import { Container } from '@material-ui/core';
import styled from 'styled-components';

export const MainContainer = styled(Container)`
  padding-top: 20vh;
  padding-bottom: 20vh;
  display: flex;
  justify-content: center;
`;
